import { useMemo, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { shopsForMap } from './shopUtils';
import { getMapCenter } from './shopsData';
import markerUrl from './assets/mmjmarker.png';
import './LandingShopsMap.css';

const MARKER_NATURAL_W = 175;
const MARKER_NATURAL_H = 226;
const MARKER_DISPLAY_H = 44;
const ICON_W = Math.round((MARKER_NATURAL_W / MARKER_NATURAL_H) * MARKER_DISPLAY_H);
const ICON_H = MARKER_DISPLAY_H;

const shopIcon = L.icon({
  iconUrl: markerUrl,
  iconSize: [ICON_W, ICON_H],
  iconAnchor: [ICON_W / 2, ICON_H],
  popupAnchor: [0, -ICON_H + 4],
  className: 'lp-shop-marker-icon',
});

function FitBounds({ positions }) {
  const map = useMap();
  useEffect(() => {
    if (!positions.length) return;
    const b = L.latLngBounds(positions);
    map.fitBounds(b, { padding: [40, 40], maxZoom: 14 });
  }, [map, positions]);
  return null;
}

export default function LandingShopsMap({ rawRows = [] }) {
  const points = useMemo(() => shopsForMap(rawRows), [rawRows]);
  const center = useMemo(() => getMapCenter(points), [points]);
  const boundsPositions = useMemo(() => points.map((p) => [p.lat, p.lng]), [points]);

  if (!points.length) return null;

  return (
    <div className="lp-shops-map-wrap">
      <MapContainer
        center={center}
        zoom={points.length > 1 ? 11 : 14}
        scrollWheelZoom={false}
        attributionControl={false}
        zoomControl={false}
        className="lp-shops-map"
      >
        <TileLayer
          // Carto free CDN now serves "API key required" placeholders — use Esri light gray (no key).
          url="https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}"
        />
        {boundsPositions.length > 1 ? <FitBounds positions={boundsPositions} /> : null}
        {points.map((shop) => (
          <Marker key={shop.id} position={[shop.lat, shop.lng]} icon={shopIcon}>
            <Popup className="lp-shop-popup">
              <strong>{shop.name}</strong>
              {shop.description?.trim() ? (
                <>
                  <br />
                  <span style={{ whiteSpace: 'pre-wrap' }}>{shop.description}</span>
                </>
              ) : null}
              {shop.mapslink?.trim() ? (
                <>
                  <br />
                  <a href={shop.mapslink} target="_blank" rel="noopener noreferrer">
                    Haritada aç
                  </a>
                </>
              ) : null}
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
